// extracted by mini-css-extract-plugin
export default {"main":"_92c9da6c87","tit":"_1b374515a9","maintitle":"_313d48b743","ylw":"_732aa70f1d","white":"_56e970b0e0","mv_title":"_860ada924d","mv_nc":"_0d81b30888","mv_in":"_5b8ba6773b"};